// import * as types from "~/store/partnerUser/types";
// import { openToast } from "~/components/common/molecules/ToastNotification";

const initialState = {

};

export default function locale(state = initialState, action = {}) {
  switch (action.type) {
    default:
      return state;
  }
}
